import { SVGProps } from "react";

const MinusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={43}
    height={43}
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.3566 39.4166C31.2108 39.4166 39.2733 31.3541 39.2733 21.4999C39.2733 11.6458 31.2108 3.58325 21.3566 3.58325C11.5024 3.58325 3.43994 11.6458 3.43994 21.4999C3.43994 31.3541 11.5024 39.4166 21.3566 39.4166Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1899 21.5H28.5233"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MinusCircle;
